import * as actions from './actions';
import reducers from './reducer';

export const AdminDashboard = { actions, reducers };
export { AdminDashboardState } from './reducer';
